import { render, staticRenderFns } from "./FreesideHeader.vue?vue&type=template&id=04deee4a&scoped=true"
import script from "./FreesideHeader.vue?vue&type=script&lang=ts"
export * from "./FreesideHeader.vue?vue&type=script&lang=ts"
import style0 from "./FreesideHeader.vue?vue&type=style&index=0&id=04deee4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04deee4a",
  null
  
)

export default component.exports